import styled from 'styled-components';
import { flexCenter } from './global';

export const MainStyle = styled.div`
  margin: 5rem auto;
  max-width: 1150px;
  transform: scale(0.9);

  .upload-name,
  input[type='text'] {
    width: 50%;
    font-size: 15px;
    padding: 13px 20px;
  }

  .inputgroup.file input[type='file'] {
    position: absolute;
    width: 0;
    height: 0;
    padding: 0;
    overflow: hidden;
    border: 0;
  }

  @media screen and (max-width: 767px) {
    margin: 1rem auto 5rem;
    padding: 0 20px;
    transform: scale(1);

    .inputgroup.file input[type='file'] {
      /* position: unset;
      width: 100%;
      height: unset;
      overflow: unset;
      font-size: 15px;
      padding: 13px 20px;
      border: 1px solid ${(props) => props.theme.colors.border}; */
    }
  }
`;

export const Group = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
  padding-bottom: 60px;
  border-bottom: 1px solid ${(props) => props.theme.colors.border};

  .border {
    display: none;
  }

  h1 {
    display: block;
    max-width: 340px;
    height: 130px;
    margin-right: 45px;
    width: 100%;
  }

  h2 {
    margin-bottom: 36px;
    font-size: ${(props) => props.theme.font.title};
  }

  .item {
    width: 100%;
  }

  .item.category input[type='text'] {
    width: 75%;
  }

  .inputgroup {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .inputgroup label {
    min-width: 130px;
    font-size: ${(props) => props.theme.font.subTitle};
  }

  .inputgroup > label:not(.checkboxLabel)::after {
    content: '*';
    color: ${(props) => props.theme.colors.orange};
  }

  .inputgroup.file > label.filebutton::after,
  .inputgroup.page label::after {
    content: '';
  }

  .inputgroup.category {
    display: flex;
    align-items: flex-start;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 80%;
  }

  .checkboxLabel {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
  }

  .upload-name {
    pointer-events: none;
  }

  .filebutton {
    padding: 13px 40px;
    background-color: ${(props) => props.theme.colors.main};
    color: ${(props) => props.theme.colors.white};
    border-radius: 5px;
    text-align: center;
    font-weight: 700;
    cursor: pointer;
    line-height: 18px;
    margin-left: 10px;
    transition: ${(props) => props.theme.transition.default};
    white-space: nowrap;
    &:hover {
      opacity: 0.8;
    }
  }

  .fileupload_group {
    width: 50%;
    position: relative;
    display: flex;

    input {
      width: 100%;
    }
  }

  .filebutton.gray {
    background-color: ${(props) => props.theme.colors.gray};
  }

  ul {
    width: auto;
    background-color: ${(props) => props.theme.colors.grayBg};
    padding: 25px 45px;
    border-radius: 10px;
    font-size: ${(props) => props.theme.font.noti};
  }

  @media screen and (max-width: 767px) {
    flex-direction: column;
    margin-bottom: 45px;
    padding-bottom: 40px;

    .border {
      display: block;
      width: 100%;
      border-bottom: 1px solid ${(props) => props.theme.colors.border};
      padding-top: 40px;
      margin-bottom: 45px;
    }

    ul {
      margin: 10px 0;
    }

    h1 {
      width: 190px;
      height: 72px;
      margin-right: 0;
      margin-bottom: 10px;
    }

    h2 {
      display: none;
    }

    ul {
      font-size: ${(props) => props.theme.font.check};
      padding: 20px;
    }

    .inputgroup {
      flex-direction: column;
      align-items: flex-start;
      gap: 5px;
      margin-bottom: 15px;
      input[type='file'],
      input[type='text'] {
        width: 100%;
      }
    }

    .filebutton,
    .upload-name {
      /* display: none; */
    }

    .list {
      width: 100%;
    }

    .item.category input[type='text'] {
      width: 100%;
    }

    .inputgroup label {
      min-width: auto;
      margin-right: 5px;
    }

    .inputgroup.category {
      flex-direction: column;
      align-items: flex-start;
    }

    .fileupload_group {
      width: 100%;

      .upload-name {
        border: 2px dashed ${(props) => props.theme.colors.border};
      }

      .upload-name.gray {
        background-color: ${(props) => props.theme.colors.grayBg};
        border: 1px solid ${(props) => props.theme.colors.border};
      }

      .filebutton,
      label {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        margin: 0;
        opacity: 0;
      }
    }
  }
`;

export const Submit = styled.div`
  position: relative;
  ${flexCenter};

  .container {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }

  .checkboxLabel {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }

  label {
    font-size: ${(props) => props.theme.font.noti};
    color: ${(props) => props.theme.colors.noti};
    font-weight: 500;
  }

  button {
    background-color: ${(props) => props.theme.colors.main};
    color: ${(props) => props.theme.colors.white};
    font-size: ${(props) => props.theme.font.noti};
    font-weight: 900;
    padding: 22px 110px;
  }
  button.loading {
    pointer-events: none;
  }

  @media screen and (max-width: 767px) {
    .container {
      width: 100%;
    }

    button {
      padding: 30px;
      font-size: ${(props) => props.theme.font.title};
    }

    label {
      font-size: 14px;
    }
  }
`;

export const Spinner = styled.div`
  position: absolute;
  top: -50%;
  left: 50%;
`;
